import { Link, Head } from '@inertiajs/react';
import { PageProps } from '@/types';
import { Icon } from '@iconify/react';
import Header from '@/Layouts/Partials/Header';
import Footer from '@/Layouts/Partials/Footer';
import { SettingModel } from '@/types/models/setting';
import FrontLayout from '@/Layouts/FrontLayout';
import { useEffect, useState } from 'react';
import HeroSlider from '@/Components/Homepage/HeroSlider';
import SliderWithDescription from '@/Components/Homepage/SliderWithDescription';
import ChoiceOnMedal from '@/Components/Homepage/ChoiceOnMedal';
import LandscapeWithBox from '@/Components/Homepage/LandscapeWithBox';
import IconsWithTexts from '@/Components/Homepage/IconsWithTexts';
import InvestmentOnMedal from '@/Components/Homepage/InvestmentOnMedal';
import FindApartment from '@/Components/Homepage/FindApartment';
import Facilities from '@/Components/Homepage/Facilities';
import ApartmentSearch from '@/Components/Homepage/ApartmentSearch';
import { SearchEngineData } from '@/types/searchEngineData';
import { GalleryModel } from '@/types/models/gallery';
import GallerySlider from '@/Components/Homepage/GallerySlider';
import News from '@/Components/Homepage/News';
import { PostModel } from '@/types/models/post';
import AboutInvestor from '@/Components/Homepage/AboutInvestor';
import ContactForm from '@/Components/Universal/ContactForm';
import { GalleryCategory } from '@/types/models/galleryCategory';
import TopHero from '@/Components/Universal/TopHero';
import CategoriesLoop from '@/Components/Gallery/CategoriesLoop';
import Container from '@/Components/Grid/Container';
import Row from '@/Components/Grid/Row';
import Column from '@/Components/Grid/Column';
import { DiaryOfBuildModel } from '@/types/models/diaryOfBuild';
import { PaginationLink } from '@/types/components/pagination/pagination';
import Pagination from '@/Components/Pagination/Pagination';
import EntryHeading from '@/Components/TenantChanges/EntryHeading';
import HowItWorks from '@/Components/TenantChanges/HowItWorks';
import WhatChangesCanBeDone from '@/Components/TenantChanges/WhatChangesCanBeDone';
import Faq from '@/Components/TenantChanges/Faq';
import DocsDownload from '@/Components/TenantChanges/DocsDownload';
import ContactCTA from '@/Components/Universal/ContactCTA';
import WelcomeSection from '@/Components/CreditService/WelcomeSection';

export default function CreditService({ }: PageProps<{
}>) {
    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name='description' content='Osiedle Kusocińskiego' />
            </Head>
            <FrontLayout>
                <TopHero withoutGradient image='credit-services.webp' text='Obsługa kredytowa klientów' asH2 />
                <WelcomeSection />
                <section>
                    <Container className='mb-24 maxMd:mb-14'>
                        <Row>
                            <Column>
                                <a href="https://finamax.pl/" target='_blank' title='Finamax'>
                                    <img src="/storage/static/finamax-banner.webp" alt="Finamax" />
                                </a>
                            </Column>
                        </Row>
                    </Container>
                </section>
                <section className='mb-24 maxMd:mb-14'>
                    <Container>
                        <Row className='justify-center'>
                            <Column xl={10}>
                                <Row className='mb-6'>
                                    <Column xl={6} lg={6}>
                                        <div className="flex gap-x-6 items-center justify-end flex-wrap maxMd:gap-y-6">
                                            <p className='text-p leading-p text-primary maxMd:w-full maxMd:order-2 maxMd:text-center'><span className='font-extrabold'>Oszczędność</span> czasu</p>
                                            <img src="/storage/icons/finamax-time.svg" alt="Osczędność czasu" className='maxMd:mx-auto' />
                                        </div>
                                    </Column>
                                    <Column xl={6} lg={6}>
                                        <div className="flex gap-x-6 items-center justify-start flex-wrap maxMd:gap-y-6 maxMd:mt-6">
                                            <img src="/storage/icons/finamax-shield.svg" alt="Bepieczeństwo" className='maxMd:mx-auto' />
                                            <p className='text-p leading-p text-primary maxMd:w-full maxMd:order-2 maxMd:text-center'><span className='font-extrabold'>Bepieczeństwo</span> - licencja KNF</p>
                                        </div>
                                    </Column>
                                </Row>
                                <Row className='mb-6 maxMd:gap-y-6'>
                                    <Column xl={6} lg={6}>
                                        <div className="flex gap-x-6 items-center justify-end flex-wrap maxMd:gap-y-6">
                                            <p className='text-p leading-p text-primary maxMd:w-full maxMd:order-2 maxMd:text-center'>Oferta <span className='font-extrabold'>najlepszych</span> banków</p>
                                            <img src="/storage/icons/finamax-check.svg" alt="Osczędność czasu" className='maxMd:mx-auto'/>
                                        </div>
                                    </Column>
                                    <Column xl={6} lg={6}>
                                        <div className="flex gap-x-6 items-center justify-start flex-wrap maxMd:gap-y-6">
                                            <img src="/storage/icons/finamax-help.svg" alt="Bepieczeństwo" className='maxMd:mx-auto'/>
                                            <p className='text-p leading-p text-primary maxMd:w-full maxMd:order-2 maxMd:text-center'>Pomoc <span className='font-extrabold'>na każdym etapie</span> procesu kredytowego</p>
                                        </div>
                                    </Column>
                                </Row>
                                <Row className='mb-6 maxMd:gap-y-6 maxMd:mb-0'>
                                    <Column xl={6} lg={6}>
                                        <div className="flex gap-x-6 items-center justify-end flex-wrap maxMd:gap-y-6">
                                            <p className='text-p leading-p text-primary maxMd:w-full maxMd:order-2 maxMd:text-center'>Opieka <span className='font-extrabold'>doświadczonego</span> eksperta</p>
                                            <img src="/storage/icons/finamax-care.svg" alt="Osczędność czasu" className='maxMd:mx-auto'/>
                                        </div>
                                    </Column>
                                    <Column xl={6} lg={6}>
                                        <div className="flex gap-x-6 items-center justify-start flex-wrap maxMd:gap-y-6">
                                            <img src="/storage/icons/finamax-offer.svg" alt="Bepieczeństwo" className='maxMd:mx-auto'/>
                                            <p className='text-p leading-p text-primary maxMd:w-full maxMd:order-2 maxMd:text-center'>Oferta <span className='font-extrabold'>dopasowana</span> do potrzeb Klienta</p>
                                        </div>
                                    </Column>
                                </Row>
                            </Column>
                        </Row>
                    </Container>
                </section>
                <section className='mb-18'>
                    <Container>
                        <Row className='justify-center'>
                            <Column xl={8}>
                                <h3 className='text-h3 maxMd:!text-h3 leading-h3 maxMd:!leading-h3 text-primary font-extrabold mb-10 maxMd:mb-8 text-center'>Bezpłatna obsługa procesu kredytowego:</h3>
                            </Column>
                        </Row>
                        <Row className='justify-center items-stretch gap-y-6'>
                            <Column xl={4} lg={6}>
                                <div className='border-[1px] border-secondary p-6 h-full min-h-[256px]'>
                                    <p className='text-label leading-label text-primary font-extrabold mb-4'>1</p>
                                    <p className='text-h4 leading-h4 text-primary font-extrabold uppercase mb-2 tracking-[0.6px]'>Przygotowanie</p>
                                    <ul className='list-disc pl-4 text-p leading-p'>
                                        <li>sprawdzenie zdolności kredytowej</li>
                                        <li>wybór najlepszych ofert bankowych</li>
                                        <li>przygotowanie listy dokumentów</li>
                                    </ul>
                                </div>
                            </Column>
                            <Column xl={4} lg={6}>
                                <div className='border-[1px] border-secondary p-6 h-full min-h-[256px]'>
                                    <p className='text-label leading-label text-primary font-extrabold mb-4'>2</p>
                                    <p className='text-h4 leading-h4 text-primary font-extrabold uppercase mb-2 tracking-[0.6px]'>Wniosek kredytowy</p>
                                    <ul className='list-disc pl-4 text-p leading-p'>
                                        <li>pomoc w kompletowaniu dokumentów</li>
                                        <li>przygotowanie wszystkich formularzy bankowych</li>
                                        <li>złożenie wniosków kredytowych w imieniu Klienta</li>
                                    </ul>
                                </div>
                            </Column>
                            <Column xl={4} lg={6}>
                                <div className='border-[1px] border-secondary p-6 h-full min-h-[256px]'>
                                    <p className='text-label leading-label text-primary font-extrabold mb-4'>3</p>
                                    <p className='text-h4 leading-h4 text-primary font-extrabold uppercase mb-2 tracking-[0.6px]'>PROCES W BANKU</p>
                                    <ul className='list-disc pl-4 text-p leading-p'>
                                        <li>stały kontakt z działem analiz</li>
                                        <li>negocjacje warunków kredytowania</li>
                                    </ul>
                                </div>
                            </Column>
                            <Column xl={4} lg={6}>
                                <div className='border-[1px] border-secondary p-6 h-full min-h-[256px]'>
                                    <p className='text-label leading-label text-primary font-extrabold mb-4'>4</p>
                                    <p className='text-h4 leading-h4 text-primary font-extrabold uppercase mb-2 tracking-[0.6px]'>UMOWA KREDYTOWA</p>
                                    <ul className='list-disc pl-4 text-p leading-p'>
                                        <li>analiza zapisów umowy przed wizytą w banku,</li>
                                        <li>obecność eksperta przy podpisaniu umowy</li>
                                    </ul>
                                </div>
                            </Column>
                            <Column xl={4} lg={6}>
                                <div className='border-[1px] border-secondary p-6 h-full min-h-[256px]'>
                                    <p className='text-label leading-label text-primary font-extrabold mb-4'>5</p>
                                    <p className='text-h4 leading-h4 text-primary font-extrabold uppercase mb-2 tracking-[0.6px]'>WYPŁATA ŚRODKÓW</p>
                                    <ul className='list-disc pl-4 text-p leading-p'>
                                        <li>pomoc w spełnieniu warunków do uruchomienia</li>
                                        <li>bezpłatne wsparcie aż do całkowitej spłaty kredytu</li>
                                    </ul>
                                </div>
                            </Column>
                        </Row>
                    </Container>
                </section>
                <ContactForm smallerMargin />
            </FrontLayout>
        </>
    );
}
